module.exports = __webpack_public_path__ + "img/icon-onestop-cover.3702f607.png";